import { Component } from '@angular/core';
import { SalesSummaryCardComponent, SalesSummaryGroup, Timespan } from 'gung-dashboard';
import { first, forkJoin, of } from 'rxjs';

@Component({
    selector: 'car-liner-sales-summary-card',
    templateUrl: './car-liner-sales-summary-card.component.html',
    styleUrl: './car-liner-sales-summary-card.component.scss',
    standalone: false
})
export class CarLinerSalesSummaryCardComponent extends SalesSummaryCardComponent{
  minDate;
  maxDate;

  protected allSalesSummaryGroups: SalesSummaryGroup[] = [];

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    this.salesSummaryGroups = (this.allSalesSummaryGroups || []).filter(data => {
      const nameMatches = data.name.toLowerCase().includes(filterValue);
      const idMatches = data.id.toString().toLowerCase().includes(filterValue);
      return nameMatches || idMatches;
    });

    this.page = 1;
    this.applySort();
  }

  protected fetchSalesSummaries() {
    console.log('fetch');
    const isToShowPreviousTimeSpan = false;
    let dateSpan: {fromDate: Date; toDate?: Date};
    let previousDateSpan: {fromDate: Date; toDate?: Date};;
    if(this.maxDate && this.minDate){
      dateSpan={
        fromDate:this.minDate /* new Date(this.minDate.year, this.minDate.month - 1, this.minDate.day) */,
        toDate: this.maxDate /* new Date(this.maxDate.year, this.maxDate.month - 1, this.maxDate.day) */
      };
    }else{
      dateSpan = this.dashboardKpiService.getDateFromTimespan(this.currentTimespan);

    }
    previousDateSpan = this.dashboardKpiService.getDateFromTimespan(this.getPreviousTimeSpan());
    forkJoin({
      salesSummaryGroups: this.dashboardKpiService
        .getSalesSummary(this.currentGroupOn, dateSpan.fromDate, dateSpan.toDate, this.preConditions)
        .pipe(first()),
      previousSalesSummaryGroups: isToShowPreviousTimeSpan
        ? this.dashboardKpiService
            .getSalesSummary(
              this.currentGroupOn,
              previousDateSpan.fromDate,
              previousDateSpan.toDate,
              this.preConditions
            )
            .pipe(first())
        : of(null)
    }).subscribe(({ salesSummaryGroups, previousSalesSummaryGroups }) => {
      this.allSalesSummaryGroups = salesSummaryGroups;
      this.salesSummaryGroups = salesSummaryGroups;


      if (isToShowPreviousTimeSpan) {
        this.previousTimespanSalesSummaryGroups = {};

        for (const salesSummaryGroup of salesSummaryGroups) {
          const previousValue = previousSalesSummaryGroups.find(previous => previous.id === salesSummaryGroup.id);
          this.showDetails[salesSummaryGroup.id] = false;
          this.details[salesSummaryGroup.id] = { color: 'UNDEFINED', size: 'UNDEFINED', img: 'UNDEFINED' };
          /*  this.details[salesSummaryGroup.id] = {color: '', size: '', img: ''}; */
          if (!!previousValue) {
            this.previousTimespanSalesSummaryGroups[salesSummaryGroup.id] = previousValue;
          } else {
            this.previousTimespanSalesSummaryGroups[salesSummaryGroup.id] = {
              ...salesSummaryGroup,
              totalAmount: 0,
              totalQuantity: 0
            };
          }
        }
      }

      this.showPreviousTimeSpan = isToShowPreviousTimeSpan;
      this.previousTimeSpanLabel = this.computePreviousTimeSpanLabel();

      this.page = 1;
      this.applySort();
    });
  }

  
  minDateSelect(value){
    this.minDate = value;
    console.log('value',value )
    if(this.maxDate && this.minDate){
      this.fetchSalesSummaries();
    }
  }

  maxDateSelect(value){
    this.maxDate = value;
    console.log('max', value)
    if(this.maxDate && this.minDate){
      this.fetchSalesSummaries();
      this.currentTimespan = null;
    }
    
  }

  changeTimespan(newTimespan: Timespan) {
    this.currentTimespan = newTimespan;
    this.fetchSalesSummaries();
    this.maxDate = null;
    this.minDate = null;
  }

}
